'use strict';

var Content = require('./src/Content.js');
var Footer = require('./src/Footer.js');
var Header = require('./src/Header.js');
var Sheet$1 = require('./src/Sheet.js');

const Sheet = Sheet$1.Sheet;
Sheet.Header = Header.Header;
Sheet.Footer = Footer.Footer;
Sheet.Content = Content.Content;

exports.Sheet = Sheet;
//# sourceMappingURL=index.js.map
